import { render, staticRenderFns } from "./kf-footer.vue?vue&type=template&id=63255b06&scoped=true"
import script from "./kf-footer.vue?vue&type=script&lang=js"
export * from "./kf-footer.vue?vue&type=script&lang=js"
import style0 from "./kf-footer.vue?vue&type=style&index=0&id=63255b06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63255b06",
  null
  
)

export default component.exports